import fetch from '@/utils/fetch';
var publicPath = '/api/v1/manager/';

/**
获取统计数据
*/
export function getAnalysisData(data) {
  return fetch({
    url: publicPath + 'daily/usage',
    method: 'post',
    data: data
  });
}

/**
  获取企业资源信息
*/
export function getCompanyUsageData(data) {
  return fetch({
    url: publicPath + 'usage',
    method: 'post',
    data: data
  });
}